import React from 'react';

export default function RequiredStatement(): React.JSX.Element {
  return (
    <p className='required-statement'>
      <span>*</span> Indicates a required field.
    </p>
  );
}
